import React from "react";
import Image from "next/image";
import { LuPlay } from "react-icons/lu";
import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "../../../public/assets/icons/vander";
import CommonUtils from "@/utils/CommonUtils";
interface Attachment {
  id: number;
  uuid: string;
  path: string;
  type: string;
}

interface Media {
  id: number;
  uuid: string;
  attachment: Attachment;
}

type Props = {
  mediaList: Media[];
};

const MediaGallery = ({ mediaList }: Props) => {
  const [currentMedia, setCurrentMedia] = React.useState<Media>(mediaList[0]);
  const [currentMediaIndex, setCurrentMediaIndex] = React.useState<number>(1);

  const [isFullScreen, setIsFullScreen] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (isFullScreen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isFullScreen]);

  return (
    <div
      className={
        isFullScreen
          ? "fixed top-0 bottom-0 left-0 right-0 h-screen w-screen  place-content-center bg-black z-50 "
          : "relative"
      }
    >
      <div className={`aspect-video relative w-full bg-slate-100 text-center `}>
        <div
          className="absolute top-[40%] cursor-pointer p-2 hover:text-green-600 grid place-content-center left-0 z-10"
          onClick={() => {
            if (currentMediaIndex === 1) return;
            setCurrentMediaIndex(currentMediaIndex - 1);
            setCurrentMedia(mediaList[currentMediaIndex - 2]);
          }}
        >
          <div className="grid p-3 place-content-center bg-black/10 rounded-full">
            <MdKeyboardArrowLeft className="text-[30px]" />
          </div>
        </div>
        {currentMedia.attachment.type === "image" && (
          <Image
            src={CommonUtils.getImagePath(currentMedia.attachment.path)}
            alt={" media -" + currentMediaIndex}
            className="h-full m-auto w-auto cursor-pointer"
            width={1500}
            height={1500}
            title={" media -" + currentMediaIndex}
            onClick={() => {
              setIsFullScreen(!isFullScreen);
            }}
          />
        )}
        {currentMedia.attachment.type === "video" && (
          <video
            className="w-full h-full cursor-pointer"
            controls
            src={CommonUtils.getImagePath(currentMedia.attachment.path)}
            onClick={() => {
              setIsFullScreen(!isFullScreen);
            }}
          ></video>
        )}
        <div
          className="absolute top-[40%]  cursor-pointer p-2 hover:text-green-600 grid place-content-center right-0 z-10"
          onClick={() => {
            if (currentMediaIndex === mediaList.length) {
              let index = 0;
              setCurrentMediaIndex(index);
              setCurrentMedia(mediaList[index]);
              return;
            }
            setCurrentMediaIndex(currentMediaIndex + 1);
            setCurrentMedia(mediaList[currentMediaIndex]);
          }}
        >
          <div className="grid p-3 place-content-center bg-black/10 rounded-full">
            <MdKeyboardArrowRight className="text-[30px]" />
          </div>
        </div>
      </div>
      {!isFullScreen && (
        <div className="flex  bg-slate-100 p-2 overflow-x-auto scroll-m-0 mt-5 items-center">
          <div className="flex space-x-2 items-center">
            {mediaList.map((media) => (
              <div
                key={media.uuid}
                className={
                  `cursor-pointer rounded w-[100px] aspect-video overflow-hidden bg-slate-300 ` +
                  (currentMedia.uuid === media.uuid
                    ? "border-2 border-green-600"
                    : "")
                }
                onClick={() => {
                  setCurrentMedia(media);
                  setCurrentMediaIndex(mediaList.indexOf(media) + 1);
                }}
              >
                {media.attachment.type === "image" && (
                  <Image
                    src={CommonUtils.getImagePath(media.attachment.path)}
                    alt={"media -" + (mediaList.indexOf(media) + 1)}
                    className="h-full m-auto w-auto"
                    width={100}
                    height={100}
                    title={"media -" + (mediaList.indexOf(media) + 1)}
                  />
                )}
                {media.attachment.type === "video" && (
                  <>
                    <div className="bg-black w-full h-full grid place-content-center">
                      <div className="grid place-content-center rounded-full border border-white aspect-square w-8">
                        <LuPlay className="text-white" />
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MediaGallery;
